var map = {
	"./01-01.mp3": 490,
	"./01-01__.mp3": 766,
	"./01-02.mp3": 767,
	"./01-03.mp3": 360,
	"./01-04.mp3": 361,
	"./01-05.mp3": 491,
	"./01-06.mp3": 768,
	"./01-07.mp3": 769,
	"./01-08.mp3": 770,
	"./01-09.mp3": 771,
	"./01-10.mp3": 772,
	"./01-11.mp3": 810,
	"./01-12.mp3": 1535,
	"./01-13.mp3": 1536,
	"./01-14.mp3": 811,
	"./04-01.mp3": 1537,
	"./04-02.mp3": 1538,
	"./04-03.mp3": 812,
	"./04.mp3": 1539,
	"./emotion-slow.mp3": 813,
	"./emotion.mp3": 1540,
	"./ex1-slow.mp3": 814,
	"./ex1.mp3": 1541,
	"./ex1_3_4-slow.mp3": 815,
	"./ex1_3_4.mp3": 1542,
	"./ex7-slow.mp3": 816,
	"./ex7.mp3": 1543,
	"./ex8-slow.mp3": 817,
	"./ex8.mp3": 1544,
	"./health-slow.mp3": 818,
	"./health.mp3": 1545,
	"./intoSleep.mp3": 499,
	"./life-cycle-slow.mp3": 819,
	"./life-cycle.mp3": 1546,
	"./life-slow.mp3": 820,
	"./life.mp3": 1547,
	"./natureFeedback.mp3": 1548,
	"./natureFeedbackEffect.mp3": 821,
	"./recognition-slow.mp3": 822,
	"./recognition.mp3": 1549,
	"./soundAlpha.mp3": 1550,
	"./soundAlpha1.mp3": 1551,
	"./soundAlpha2.mp3": 1552,
	"./soundAttemption.mp3": 773,
	"./soundAttemptionNew.mp3": 1553,
	"./soundBalance.mp3": 775,
	"./soundBalanceF.mp3": 1554,
	"./soundBalanceNew.mp3": 1555,
	"./soundConst.mp3": 774,
	"./soundConstNew.mp3": 1556,
	"./soundRest.mp3": 362,
	"./soundRestNew.mp3": 1557,
	"./view5-ex1-slow.mp3": 823,
	"./view8-ex1-slow.mp3": 824,
	"./view9-ex1-slow.mp3": 825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1534;